import React, { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Outlet } from "react-router-dom";
import { useSyncBackofficeTenantScope } from "@/hooks";
import { BackofficeSidebar } from "./BackofficeSidebar";
import { BackofficeTopBar } from "./BackofficeTopBar";
import "./BackofficeLayout.scss";

/**
 * Shell layout for backoffice pages with drawer sidebar.
 */
export const BackofficeLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [title, setTitle] = useState<string | undefined>();

  useSyncBackofficeTenantScope();

  return (
    <Dialog.Root open={isSidebarOpen} onOpenChange={setIsSidebarOpen}>
      <div className="backoffice-layout">
        <BackofficeTopBar title={title} />
        <Dialog.Portal>
          <Dialog.Overlay className="backoffice-layout__backdrop" />
          <BackofficeSidebar onClose={() => setIsSidebarOpen(false)} />
        </Dialog.Portal>
        <main className="backoffice-layout__main">
          <Outlet context={{ setTitle }} />
        </main>
      </div>
    </Dialog.Root>
  );
};
